import Model from "./model";
import Color from "./color";
import ColorDefinition from "./ColorDefinition";
import { getRandomString } from "../utils/string";

const NEW_STATUS = "New Status";

export interface WorkflowStatusData {
    _id?: string;
    color?: ColorDefinition;
    name?: string;
}

export default class WorkflowStatus extends Model {
    _id: string;
    color: Color;
    name?: string;

    static All = new WorkflowStatus({
        _id: "All",
        name: "All",
        color: new Color({
            name: "karl", r: 237, g: 236, b: 237
        })
    });

    static NoStatus = new WorkflowStatus({
        _id: "No Status",
        name: "No Status",
        color: new Color({
            name: "clooney", r: 193, g: 190, b: 193
        })
    });

    constructor(workflowStatus: WorkflowStatusData) {
        super();

        const {
            _id = `newWorkflowStatusId-${getRandomString()}`,
            name,
            color = new Color({
                name: "yellow", r: 254, g: 207, b: 51
            })
        } = workflowStatus;

        this._id = _id;
        this.name = name;
        this.color = new Color(color);
    }

    static generateNew(previousName?: string) {
        if (!previousName || !previousName.startsWith(NEW_STATUS)) {
            return new WorkflowStatus({ name: NEW_STATUS });
        }

        const counter = parseInt(previousName.substring(NEW_STATUS.length), 10) || 0;
        return new WorkflowStatus({ name: `New Status ${counter + 1}` });
    }
}
